import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Status } from "../../common/constants";
import { RootState } from "../../store";
import { ISinglewireSiteApi } from "../../common/types/singlewireTypes";
import api from "../../api";
import { mapSinglewireSitesUrl } from "../../config";

export const MAP_SINGLEWIRESITES: string = "mapSinglewireSites";

const initialState: ISinglewireSiteApi = {
  singlewireSite: null,
  status: Status.IDLE,
  error: null,
};

export const mapSinglewireSiteData = createAsyncThunk(
  MAP_SINGLEWIRESITES,
  async (payload: any, { rejectWithValue }) => {
    try {
      const userId = payload?.userId;
      const sites = payload?.sites;
      const response = await api.post(
        mapSinglewireSitesUrl + `userId=${userId}`,
        sites
      );
      const mapSitesResponse = response.data;
      return mapSitesResponse;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

const mapSinglewireSitesSlice = createSlice({
  name: MAP_SINGLEWIRESITES,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(mapSinglewireSiteData.pending, (state) => {
        state.status = Status.PENDING;
      })
      .addCase(mapSinglewireSiteData.fulfilled, (state, action) => {
        state.status = Status.SUCCESS;
        state.singlewireSite = action.payload;
      })
      .addCase(mapSinglewireSiteData.rejected, (state, action) => {
        state.status = Status.FAILED;
        state.error = action.error.message || null;
      });
  },
});

export const selector = (state: RootState) => state.mapSinglewireSitesApi;

export const reducer = mapSinglewireSitesSlice.reducer;
